module.exports = __webpack_public_path__ + "static/media/splash-ttl.c96ef0e3.png";